import { render, staticRenderFns } from "./StudentTimetableGroup.vue?vue&type=template&id=263def94&scoped=true&lang=pug&"
import script from "./StudentTimetableGroup.vue?vue&type=script&lang=ts&"
export * from "./StudentTimetableGroup.vue?vue&type=script&lang=ts&"
import style0 from "./StudentTimetableGroup.vue?vue&type=style&index=0&id=263def94&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263def94",
  null
  
)

export default component.exports